import { useEffect, useState, FC } from 'react';
import LoadingOverlay, { LoadingDisplay } from '../../../common/LoadingOverlay';
// import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import Button from '../../../common/form/Button';
// import { ApiResult } from '../../../../api/Shared';
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup, Label, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import {
    propertyUnits,
    updateUnit,
    getUnitListByPropertyId,
    deleteUnit,
    uploadCSV,
    addUnit,
    getIntegrationIdsByTypeAndPropertyId
} from '../../../../api/PropertyUnits';
import {
    PropertyInfo,
    activateMasterLock,
    getPropertyById,updateAvailabilityWithPms
} from '../../../../api/Property';
import '../../../../styles/PropertyUnits.css';
import '../../../../styles/Toggle.css';

import { exportLog } from '../../../../utilities/exportLog';
// import ListViewIcon from './../../../../images/list-view.png';
// import ListViewWhiteIcon from './../../../../images/list-view-white.png';
// import GridViewIcon from './../../../../images/grid-view.png';
// import GridViewWhiteIcon from './../../../../images/grid-view-white.png';

import CopyIcon from './../../../../images/copy.png';
// import FilterIcon from './../../../../images/filter.png';

// import SyncIcon from './../../../../images/sync.png';
// import SyncDisabled from './../../../../images/sync-disabled.png';
import UnitManagementTable from './UnitManagementTable';
import RichTextEditor from 'react-rte';
import * as identity from './../../../../utilities/identity';
import { ColorConstants, Roles } from './../../../../utilities/Enums';
import { ButtonGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
// import UnitManagementCard from './UnitManagementCard';
import Head1Text from '../../../common/Head1Text';
import { fetchPropertyKeys, getAdvancedConfiguration } from '../../../../api/PropertyIntegration';
import React from 'react';
import { AdvancedConfiguration } from '../../../../api/PropertyIntegration';
import SearchableDropdownClear from '../../../common/SearchableDropdownClear';
import {userIsCompanyManageUser,userIsPropertyManageUser,userIsSystemManageUser} from '../../../../utilities/identity';
import MinimalMultiSelect from '../../../common/MinimalMultiSelect';

interface Props {
    propertyId: number;
    propertyInfo: PropertyInfo;
    advancedConfiguration: AdvancedConfiguration;
    refreshProperty: () => void;
}

let initialPropertyUnit: propertyUnits = {
    id: 0,
    beaconMajor: 0,
    yardiLeaseStatus: "",
    yardiRentReady: false,
    entrataAvailabilityStatus: "",
    onesiteVacant: false,
    onesiteAvailable: false,
    onesiteMadeReady: false,
    pms_property_id: 0,
    pms_property_name: "",
    pms_unit_id: "",
    pms_unit_display_name: "",
    unit_type: "",
    bed: 0,
    bath: 0,
    sqft: 0,
    floor: "",
    model_unit: false,
    starting_price: 0,
    lock_type: 0,
    property_unit_type: 0,
    show: false,
    access_enabled: false,
    syncUnitAvailability: false,
    smartRentRemoteUnitId: "",
    directions: RichTextEditor.createValueFromString('', 'html'),
    available: false,
    keyCafeUnitKeys: []
}

let filterDefaultValue = {
    unitType: 0,
    accessEnabled: 0,
    rentReady: 0,
    available: 0,
    leaseStatus: 0,
    entrataAvailabilityStatus: 0,
    onesiteVacant: 0,
    onesiteAvailable: 0,
    onesiteMadeReady: 0,
    modalUnit: 0,
    bed: 0,
    bath: 0,
    floor: "",
}

const UnitManagementTab = (props: Props) => {

    let propertyUnitsList: propertyUnits[] = []
    const [isLoading, setIsLoading] = useState(false);
    const [updateProgress, setUpdateProgress] = useState(false);
    const [propertyList, setPropertyList] = useState(propertyUnitsList);
    const [originalPropertyList, setOriginalPropertyList] = useState(propertyUnitsList);
    const [editModal, setEditModal] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [filterModal, setFilterModal] = useState(false);
    const [newUnit, setNewUnit] = useState(initialPropertyUnit);
    const [editUnit, setEditUnit] = useState<propertyUnits>();
    const [uploadFile, setUploadFile] = useState<any>();
    // const [view, setView] = useState('TABLE');
    const view = 'TABLE';
    const accessSelectionErr = 'Please select access to enter the integration ID';
    const integrationIdErr = 'Integration ID is required';
    const [filter, setFilter] = useState(filterDefaultValue);
    const [filterData, setFilterData]: any = useState([]);
    const [searchData, setSearchData]: any = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [searchApplied, setSearchApplied] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [deletionError, setDeletionError] = useState<string | undefined>();
    const [deletionLoading, setDeletionLoading] = useState(false);
    const [updateCountLoading, setUpdateCountLoading] = useState(false);
    const [deletionUnitId, setDeletionUnitId] = useState(0);
    const [availability, setAvailability] = useState<any>({});

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [propertyType, setPropertyType] = useState("");
    const [activeTab, setActiveTab] = useState("1");
    const [showAvailableForTour, setShowAvailableForTour] = useState(false);
    const [modifyFlagUnitDetails, setModifyFlagUnitDetails] = useState<propertyUnits | undefined>();
    const [showTourEnableDetails, setShowTourEnableDetails] = useState<propertyUnits | undefined>();
    const availabilityDialog: any = {
        "Yardi": "Unit must be vacant to enable access.",
        "OneSite": "Unit must be Vacant, MadeReady and Available to enable access",
        "Entrata": "Unit must be Vacant, Ready and Available to enable access"
    }
    const [integrationDrop, setIntegrationDrop] = useState([]);
    const accessTypeList = [
        {
            'id': 1,
            'option': 'Smart Rent'
        },
        {
            'id': 2,
            'option': 'Butterfly MX'
        },
        {
            'id': 3,
            'option': 'Stratis'
        },
        {
            'id': 4,
            'option': 'Latch'
        },
        {
            'id': 5,
            'option': 'GeoKey'
        },
        {
            'id': 6,
            'option': 'AmazonKey'
        },
        {
            'id': 7,
            'option': 'BrivoKey'
        },
        {
            'id': 8,
            'option': 'MasterLockKey'
        },
        {
            'id': 9,
            'option': 'KeyCafe'
        }

    ]

    const [accessTypes, setAccessTypes] = useState(accessTypeList);
    const [integrationLoading, setIntegrationLoading] = useState(false);
    const [errText, setErrText] = useState('');
    const [lockSubmitted, setLockSubmitted] = useState(false)
    const [confirmEditState, setConfirmEditState] = useState(true)
    const [submitEditUnit, editData] = useState<propertyUnits>()

    useEffect(()=>{
        if(confirmEditState && lockSubmitted && submitEditUnit){
            handleEdit(submitEditUnit);
            toggle();
        }
        if(editUnit && editUnit.lock_type !==0 && editUnit.smartRentRemoteUnitId!=="" && errText === accessSelectionErr){
            setErrText('')
        }
    },[editUnit])

    useEffect(()=>{
        if(editModal){
            if(editUnit && editUnit.lock_type === 9){
                getIntegrationIds(editUnit.lock_type)
            }
        }
    },[editModal])

    useEffect(()=>{
        if(newUnit && newUnit.lock_type !==0 && newUnit.smartRentRemoteUnitId!=="" && errText === accessSelectionErr){
            setErrText('')
        }
    },[newUnit])

    const toggleDrop = () => {
        setDropdownOpen(prevState => !prevState);
    };
    //const [propInfo, setPropInfo]: any = useState({});

    const [showOccupied, setShowOccupied] = useState(false);

    const handleShowOccupied = () => {
        setShowOccupied(false);
    }

    const getIntegrationIds = (integrationType: number) => {
        if(integrationType === 9){
             fetchPropertyKeys(props.propertyId).then(result=>{
                if (result.success && result.data !== undefined) {
                    setIntegrationLoading(false);
                    const resData = result.data.map((item: any) => ({
                        id: item && item.id? item.id : 0,
                        keyId: item.keyId,
                        keyName: item.keyName,
                        propertyUnitId: editUnit && editUnit.id? editUnit.id : 0
                    }));
                    setIntegrationDrop(resData);
                }else{
                    setIntegrationLoading(false);
                }
             })
        } else {
            getIntegrationIdsByTypeAndPropertyId(integrationType.toString(),props.propertyId).then(result => {
                if (result.success && result.data !== undefined) {
                    setIntegrationLoading(false);
                    setIntegrationDrop(result.data);
                }else{
                    setIntegrationLoading(false);
                }
            })
        }  
    }

    const role = identity.getMyRole();
    const canSeeManage =
        role === Roles.SystemAdmin;

    const canSeeManageFloor =
        role === Roles.SystemAdmin || role === Roles.CompanyAdmin || role === Roles.PropertyAdmin;

    const isAdmin =
        role === Roles.SystemAdmin || role === Roles.CompanyAdmin || role === Roles.PropertyAdmin;

    const isUser = (
        userIsCompanyManageUser() ||
        userIsPropertyManageUser() ||
        userIsSystemManageUser()
    );
const canNotEdit = isAdmin && isUser;

    useEffect(() => {
        if (props.propertyId) {
            getPropertyById(props.propertyId).then((propInfoData) => {
                //setPropInfo(propInfoData.data);
                getUnitListByPropertyId(props.propertyId).then(result => {
                    if (result.success && result.data !== undefined) {
                        setIsLoading(false);
                        setOriginalPropertyList(result.data);
                        setPropertyList(result.data);
                        if (propInfoData.data != null && propInfoData.data['enableUnitManagement']) {
                            if (propInfoData.data.unitManagementId == 2) {
                                setPropertyType("Yardi")
                            } else if (propInfoData.data.unitManagementId == 3) {
                                setPropertyType("OneSite")
                            } else if (propInfoData.data.unitManagementId == 1) {
                                setPropertyType("Entrata")
                            } else {
                                setPropertyType("")
                            }


                        } else {
                            setPropertyType("")
                        }
                        // computePagination(result.data);
                    }
                })
            });

            getAdvancedConfiguration(props.propertyId).then((advData) => {
                if (advData != undefined && advData.data != undefined) {
                    let updatedAccessTypes = [...accessTypeList]; 
                    
                    if (advData.data.smartRentConfiguration == null) {
                        updatedAccessTypes = updatedAccessTypes.filter(item => item.id !== 1);
                    }
                    if (advData.data.bMXConfiguration == null) {
                        updatedAccessTypes = updatedAccessTypes.filter(item => item.id !== 2);
                    }
                    if (advData.data.stratisConfiguration == null) {
                        updatedAccessTypes = updatedAccessTypes.filter(item => item.id !== 3);
                    }
                    if (advData.data.latchConfiguration == null) {
                        updatedAccessTypes = updatedAccessTypes.filter(item => item.id !== 4);
                    }
                    if (advData.data.geokeyConfiguration == null) {
                        updatedAccessTypes = updatedAccessTypes.filter(item => item.id !== 5);
                    }

                    setAccessTypes(updatedAccessTypes);
                }
            });
        }

    }, [updateProgress, props.propertyId]);

    useEffect(() => {
        if (filterApplied) {
            handleFilter(false)
        }
    }, [originalPropertyList])

    const toggle = () => {
        setErrText('');
        setIntegrationDrop([]);
        setEditModal(!editModal);
    };
    const toggleAdd = () => {
        setErrText('');
        setIntegrationDrop([]);
        setNewUnit((data)=>{
            return {
                ...data,
                lock_type: 0,
                smartRentRemoteUnitId: ''
            }
        });
        setAddModal(!addModal)};
    const toggleFilter = () => setFilterModal(!filterModal);

    const handleAdd = (unit: propertyUnits) => {
        setIsLoading(true);
        unit = {
            ...unit,
            directions: unit.directions.toString('html')
        }
        addUnit(props.propertyId, unit).then(result => {
            if (result.success) {
                setUpdateProgress(!updateProgress)
            }
        })
    };

    const handleEdit = (unit: propertyUnits) => {
        setIsLoading(true)
        unit = {
            ...unit,
            directions: unit.directions.toString('html'),
        }
        updateUnit(props.propertyId, unit).then(result => {
            if (result.success) {
                setUpdateProgress(!updateProgress)
            }
        });
    };

    const handleModifyFlag = (unit: propertyUnits) => {
        setIsLoading(true)
        updateUnit(props.propertyId, unit).then(result => {
            if (result.success) {
                setUpdateProgress(!updateProgress)
            }
        });

    };

    const handleDelete = (id: number) => {
        deleteUnit(id).then(result => {
            setDeletionLoading(true);

            if (result.success) {
                setUpdateProgress(!updateProgress);
            } else {
                setDeletionError(result.error);
            }
            setDeletionLoading(false);
            setDeletionUnitId(0);
        });
    }
    async function parseAvailabilityUpdate(result: any) {
        const pattern = /Units Vacant:\s*(\d+)\s*-\s*Units Occupied:\s*(\d+)/;
        const matches = result.data.match(pattern);
        if(matches){
            result.UnitsVacant = matches[1];
            result.UnitsOccupied = matches[2];
        }
        return result;
    }
    const handleSyncPMS = (id: number) => {
        setUpdateCountLoading(true);
        updateAvailabilityWithPms(id).then(async result => {
            if (result.success && result.data) {
                setUpdateCountLoading(false);
                const parsedRes: any = await parseAvailabilityUpdate(result);
                setAvailability(parsedRes);
                props.refreshProperty();
            }
            else {
                setUpdateCountLoading(false);
                setAvailability(result);

            }
        });
    }
    function shouldDisableButton() {
        const { enableUnitManagement, unitManagementId, syncPropertyUnitsAvailability } = props.propertyInfo;
        const { advancedConfiguration } = props;
        if (!enableUnitManagement || !advancedConfiguration || !syncPropertyUnitsAvailability) return true;
        const { entrataConfiguration, yardiConfiguration, oneSiteConfiguration } = advancedConfiguration;
        if (
            (unitManagementId === 1 && entrataConfiguration == null) ||
            (unitManagementId === 2 && yardiConfiguration == null) ||
            (unitManagementId === 3 && oneSiteConfiguration == null)
        ) {
            return true;
        }    
        return false;
    }
    
    

    useEffect(() => {
        handleSearch();
    }, [filterApplied, searchText])

    const handleSearch = () => {
        const str = searchText; // Convert search input to lowercase
        let results = filterApplied ? filterData : originalPropertyList;
        if (str !== '') {
            results = results.filter((obj: any) =>
                obj.pms_unit_display_name.toLowerCase().includes(str) // Convert property to lowercase for comparison
            );
            setSearchApplied(true);
            setSearchData(results);
        }
        setTimeout(() => {
            setPropertyList(results);
        }, 100);
    }

    const resetFilter = () => {
        setFilterData([]);
        setFilter(filterDefaultValue);
        setFilterApplied(false);
        toggleFilter();
    }

    const resetFilterOnly = () => {
        setFilterData([]);
        setFilter(filterDefaultValue);
        setFilterApplied(false);
    }

    const handleFilter = (updateToggle: boolean) => {
        setFilterApplied(false);
        let results = searchApplied ? searchData : originalPropertyList;
        let filteredData = results.filter((item: any) => {
            if (
                (filter.bed === 0 || item.bed === filter.bed) &&
                (filter.bath === 0 || item.bath === filter.bath) &&
                (filter.floor === "" || item.floor === filter.floor)
            ) {
                return true
            }
            return false
        });
        if (filter.accessEnabled !== 0) {
            if (filter.accessEnabled === 1) {
                filteredData = filteredData.filter((item: any) => {
                    return item.access_enabled === true
                })
            }
            if (filter.accessEnabled === 2) {
                filteredData = filteredData.filter((item: any) => {
                    return item.access_enabled === false
                })
            }
        }
        if (filter.rentReady !== 0) {
            if (filter.rentReady === 1) {
                filteredData = filteredData.filter((item: any) => {
                    return item.yardiRentReady === true
                })
            }
            if (filter.rentReady === 2) {
                filteredData = filteredData.filter((item: any) => {
                    return item.yardiRentReady === false
                })
            }
        }
        if (filter.leaseStatus !== 0) {
            if (filter.leaseStatus === 1) {
                filteredData = filteredData.filter((item: any) => {
                    return item.yardiLeaseStatus === 'leased'
                })
            }
            if (filter.leaseStatus === 2) {
                filteredData = filteredData.filter((item: any) => {
                    return item.yardiLeaseStatus === 'on_notice'
                })
            }
            if (filter.leaseStatus === 3) {
                filteredData = filteredData.filter((item: any) => {
                    return item.yardiLeaseStatus === 'available'
                })
            }
            if (filter.leaseStatus === 4) {
                filteredData = filteredData.filter((item: any) => {
                    return item.yardiLeaseStatus === 'leased_reserved'
                })
            }
            if (filter.leaseStatus === 5) {
                filteredData = filteredData.filter((item: any) => {
                    return item.yardiLeaseStatus === 'other'
                })
            }
        }
        if (filter.entrataAvailabilityStatus !== 0) {
            if (filter.entrataAvailabilityStatus === 1) {
                filteredData = filteredData.filter((item: any) => {
                    return item.entrataAvailabilityStatus === 'Vacant Ready (Available)'
                })
            }
            if (filter.entrataAvailabilityStatus === 2) {
                filteredData = filteredData.filter((item: any) => {
                    return item.entrataAvailabilityStatus === 'Vacant Ready (Unavailable)'
                })
            }
            if (filter.entrataAvailabilityStatus === 3) {
                filteredData = filteredData.filter((item: any) => {
                    return item.entrataAvailabilityStatus === 'Vacant Not Ready (Unavailable)'
                })
            }
            if (filter.entrataAvailabilityStatus === 4) {
                filteredData = filteredData.filter((item: any) => {
                    return item.entrataAvailabilityStatus === 'Vacant Not Ready (Available)'
                })
            }
            if (filter.entrataAvailabilityStatus === 5) {
                filteredData = filteredData.filter((item: any) => {
                    return item.entrataAvailabilityStatus === 'On Notice (Unavailable)'
                })
            }
            if (filter.entrataAvailabilityStatus === 6) {
                filteredData = filteredData.filter((item: any) => {
                    return item.entrataAvailabilityStatus === 'On Notice (Available)'
                })
            }
            if (filter.entrataAvailabilityStatus === 7) {
                filteredData = filteredData.filter((item: any) => {
                    return item.entrataAvailabilityStatus === 'Occupied (Unavailable)'
                })
            }
        }
        if (filter.onesiteVacant !== 0) {
            if (filter.onesiteVacant === 1) {
                filteredData = filteredData.filter((item: any) => {
                    return item.onesiteVacant === true
                })
            }
            if (filter.onesiteVacant === 2) {
                filteredData = filteredData.filter((item: any) => {
                    return item.onesiteVacant === false
                })
            }
        }
        if (filter.onesiteAvailable !== 0) {
            if (filter.onesiteAvailable === 1) {
                filteredData = filteredData.filter((item: any) => {
                    return item.onesiteAvailable === true
                })
            }
            if (filter.onesiteAvailable === 2) {
                filteredData = filteredData.filter((item: any) => {
                    return item.onesiteAvailable === false
                })
            }
        }
        if (filter.onesiteMadeReady !== 0) {
            if (filter.onesiteMadeReady === 1) {
                filteredData = filteredData.filter((item: any) => {
                    return item.onesiteMadeReady === true
                })
            }
            if (filter.onesiteMadeReady === 2) {
                filteredData = filteredData.filter((item: any) => {
                    return item.onesiteMadeReady === false
                })
            }
        }
        if (filter.available !== 0) {
            if (filter.available === 1) {
                filteredData = filteredData.filter((item: any) => {
                    return item.available === true
                })
            }
            if (filter.available === 2) {
                filteredData = filteredData.filter((item: any) => {
                    return item.available === false
                })
            }
        }
        if (filter.modalUnit !== 0) {
            if (filter.modalUnit === 1) {
                filteredData = filteredData.filter((item: any) => {
                    return item.model_unit === true
                })
            }
            if (filter.modalUnit === 2) {
                filteredData = filteredData.filter((item: any) => {
                    return item.model_unit === false
                })
            }
        }
        setFilterData(filteredData);
        if (updateToggle) {
            toggleFilter();
        }
        setTimeout(() => {
            setFilterApplied(true);
        });
    }

    const handleCSV = (file: FileList | null) => {
        if (file) {
            // const fileRef = file[0] || "";
            // const reader = new FileReader();
            // reader.onload = (e) => {
            //     e.target &&
            //         setUploadFile(reader.result)
            // }
            // reader.readAsText(fileRef)
            setUploadFile(file[0]);
        }
    };

    const submitCSV = (id: number, uploadFile: any) => {
        if (!uploadFile) {
            return;
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append('file', uploadFile);
        uploadCSV(id, formData).then(result => {
            if (result.success) {
                setUpdateProgress(!updateProgress)
            }
        });
    };

    const copyToClipboard = (text: any) => {
        navigator.clipboard.writeText(text)
            .then(function () {
                console.log("Text copied to clipboard: " + text);
            })
            .catch(function (err) {
                console.error("Unable to copy text: " + err);
            });
    };

    const downloadTemplate = () => {
        var columns = "pms_property_id,pms_property_name,pms_unit_id,pms_unit_display_name,unit_type,bed,bath,sqft,floor,model_unit,starting_price";
        exportLog(`template`, columns);
    }

    const downloadUnits = () => {
        var data = "pms_property_id,pms_property_name,pms_unit_id,pms_unit_display_name,unit_type,bed,bath,sqft,floor,model_unit,starting_price";
        propertyList.forEach(i => {
            data += '\n';
            data += `"${i.pms_property_id}"`;
            data += `,"${i.pms_property_name}"`;
            data += `,"${i.pms_unit_id}"`;
            data += `,"${i.pms_unit_display_name}"`;
            data += `,"${i.unit_type}"`;
            data += `,"${i.bed}"`;
            data += `,"${i.bath}"`;
            data += `,"${i.sqft}"`;
            data += `,"${i.floor}"`;
            data += `,"${i.model_unit}"`;
            data += `,"${i.starting_price}"`;
        });
        exportLog(`propertyunits`, data);
    }

    const renderName = (unit: propertyUnits, table?: boolean) => {
        return (
            <>
                <Label className='m-0'>{unit.pms_unit_display_name}</Label>
                {/* <br />
                <Label style={{ fontSize: 12, margin: 0 }}>{unit.property_unit_type && unit.property_unit_type === 1 ? "(Common Area)" : "(Unit)"}</Label> */}
            </>
        )
    }

    const renderUnitId = (unit: propertyUnits, table?: boolean) => {
        return (
            <Label style={{ fontSize: 12 }}> {unit.pms_unit_id} </Label>
        )
    }

    const renderLockType = (unit: propertyUnits, table?: boolean) => {
        return (
            <>
                <Label>
                    {(() => {
                        switch (unit.lock_type) {
                            case 1:
                                return 'Smartrent';
                            case 2:
                                return 'Butterfly MX';
                            case 3:
                                return 'Stratis';
                            case 4:
                                return 'Latch';
                            case 5:
                                return 'GeoKey';
                            case 6:
                                return 'AmazonKey';
                            case 7:
                                return 'BrivoKey';
                            case 8:
                                return 'MasterLockKey';
                            case 9:
                                return 'KeyCafe';
                            default:
                                return 'No Integration';
                        }
                    })()}
                </Label>
                {unit.lock_type > 0 && unit.lock_type < 5 &&
                    <button className='copy-button' onClick={() => copyToClipboard(unit.smartRentRemoteUnitId)} title='Copy Integration Id'>
                        <img
                            className="unit-icon"
                            src={CopyIcon}
                        />
                    </button>
                }

            </>
        )
    }

    const renderLeaseStatus = (unit: any, isTable?: boolean) => {
        if (unit.yardiLeaseStatus) {
            return <Label style={{ textTransform: 'capitalize' }}>{unit.yardiLeaseStatus.replace("_", " ")}</Label>
        }

        return <></>

    }

    const renderRentReady = (unit: any, isTable?: boolean) => {
        if (unit.yardiRentReady === true || unit.yardiRentReady === false) {
            return <Label style={{ textTransform: 'capitalize' }}>{`${unit.yardiRentReady}`}</Label>
        }

        return <></>

    }

    const renderEntrataAvailabilityStatus = (unit: any, isTable = false) => {
        return (
            <div className={`align-items-center d-flex ${isTable ? 'justify-content-center' : ''}`}>
                {unit.entrataAvailabilityStatus === "Vacant Ready (Available)" ? (
                    <span className="badge rounded-pill bg-success text-light">{unit.entrataAvailabilityStatus}</span>
                ) : (
                    <span className="badge rounded-pill bg-warning text-dark">{unit.entrataAvailabilityStatus}</span>
                )}
            </div>
        );
    };


    const renderOnesiteVacant = (unit: any, isTable?: boolean) => {

        return (<div className={`align-items-center d-flex ${isTable ? 'justify-content-center' : ''}`}>
            {unit.onesiteVacant &&
                <span className="badge rounded-pill bg-success text-light">True</span>
            }
            {!unit.onesiteVacant &&
                <span className="badge rounded-pill bg-warning text-dark">False</span>
            }
        </div>)
    }

    const renderOnesiteAvailable = (unit: any, isTable?: boolean) => {
        return (<div className={`align-items-center d-flex ${isTable ? 'justify-content-center' : ''}`}>
            {unit.onesiteAvailable &&
                <span className="badge rounded-pill bg-success text-light">True</span>
            }
            {!unit.onesiteAvailable &&
                <span className="badge rounded-pill bg-warning text-dark">False</span>
            }
        </div>)
    }

    const renderOnesiteMadeReady = (unit: any, isTable?: boolean) => {
        return (<div className={`align-items-center d-flex ${isTable ? 'justify-content-center' : ''}`}>
            {unit.onesiteMadeReady &&
                <span className="badge rounded-pill bg-success text-light">True</span>
            }
            {!unit.onesiteMadeReady &&
                <span className="badge rounded-pill bg-warning text-dark">False</span>
            }
        </div>)
    }


    const renderAvailableForTour = (unit: any, isTable?: boolean) => {
        return (<div className={`align-items-center d-flex ${isTable ? 'justify-content-center' : ''}`}>
            {unit.available &&
                <span className="badge rounded-pill bg-success text-light">Vacant</span>
            }
            {!unit.available &&
                <span className="badge rounded-pill bg-warning text-dark">Occupied</span>
            }
        </div>)
    }

    const renderAccessEnabled = (unit: any, isTable?: boolean) => {
        return (<div className={`align-items-center d-flex ${isTable ? 'justify-content-center' : ''}`}>
            <label className="switch">
                <input
                    type="checkbox"
                    role="switch"
                    checked={unit.access_enabled}
                    disabled={canNotEdit}
                    onChange={() => {

                        let change = true

                        if (propertyType === "Entrata" && unit.property_unit_type == 0 && !unit.access_enabled && unit.entrataAvailabilityStatus != null && unit.entrataAvailabilityStatus !== "Vacant Ready (Available)") {
                            change = false
                            setShowOccupied(true);
                        }

                        else if (propertyType === "OneSite" && unit.property_unit_type == 0 && !unit.access_enabled && (!unit.onesiteVacant || !unit.onesiteAvailable || !unit.onesiteMadeReady)) {
                            change = false
                            setShowOccupied(true);
                        }

                        else if (propertyType === "Yardi" && unit.property_unit_type == 0 && !unit.access_enabled && !unit.available) {
                            change = false
                            setShowOccupied(true);
                        } else {
                            setShowOccupied(false);
                        }

                        if (change) {
                            if (unit.property_unit_type == 0 && !unit.access_enabled) {
                                setModifyFlagUnitDetails(unit)
                            } else {
                                unit = {
                                    ...unit,
                                    access_enabled: !unit.access_enabled,
                                }
                                handleModifyFlag(unit);
                            }
                        }


                    }}
                />
                <span className="slider round" />
            </label>
        </div>)
    }

    // const renderModelUnitSwitch = (unit: any, isTable?: boolean) => {
    //     return (<div className={`align-items-center d-flex ${isTable ? 'justify-content-center' : ''}`}>
    //         <label className="switch">
    //             <input
    //                 type="checkbox"
    //                 role="switch"
    //                 checked={unit.model_unit}
    //                 onChange={() => {
    //                     unit = {
    //                         ...unit,
    //                         model_unit: !unit.model_unit,
    //                     }
    //                     handleModifyFlag(unit);
    //                 }}
    //             />
    //             <span className="slider round" />
    //         </label>
    //     </div>)
    // }

    // const renderAvailableSync = (unit: any, isTable?: boolean) => {
    //     return (<div className={`align-items-center d-flex ${isTable ? 'justify-content-center' : ''}`}>
    //         {unit.syncUnitAvailability &&
    //             <Button key={'filter'} text={''} addlClassName={`mr-1 sync-btn ${!isTable ? 'p-0' : ''}`} suppressBottomMargin={true} onClick={() => {
    //                 unit = {
    //                     ...unit,
    //                     syncUnitAvailability: false,
    //                 }
    //                 handleModifyFlag(unit);
    //             }}>
    //                 <img
    //                     className="fliter-icon"
    //                     src={SyncIcon}
    //                 />
    //             </Button>
    //         }
    //         {!unit.syncUnitAvailability &&
    //             <Button key={'filter'} text={''} addlClassName={`mr-1 sync-btn ${!isTable ? 'p-0' : ''}`} suppressBottomMargin={true} onClick={() => {
    //                 unit = {
    //                     ...unit,
    //                     syncUnitAvailability: true,
    //                 }
    //                 handleModifyFlag(unit);
    //             }}>
    //                 <img
    //                     className="fliter-icon"
    //                     src={SyncDisabled}
    //                 />
    //             </Button>
    //         }
    //     </div>)
    // }

    const renderAction = (unit: any) => {
        return (
            <div className='align-items-center d-flex justify-content-center'>
                
                <Button text="Edit" disabled={isAdmin && canNotEdit} addlClassName="btn-primary btn-sm mr-2" onClick={() => {
                    unit = {
                        ...unit,
                        ...{
                            available: unit.available || false,
                            directions: RichTextEditor.createValueFromString(unit.directions ? unit.directions : '', 'html')
                        }
                    }
                    setEditUnit(unit);
                    setIntegrationLoading(true);
                    setIntegrationDrop([])
                    getIntegrationIds(unit.lock_type);
                    toggle();

                }}
                />
                
                {canSeeManage &&
                    <Button text="Delete" disabled={!canSeeManage || !isAdmin || canNotEdit} addlClassName="btn-danger btn-sm mr-2" onClick={() => {
                        setDeletionUnitId(unit.id)
                    }} />
                }
            </div>
        )
    }

    interface AnnouncementCardProps {
        text: string;
    }

    const AnnouncementCard: FC<AnnouncementCardProps> = ({ text }) => {
        return (
            <>
                <div className="announcement-card">
                    <div className="announcement-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0002 4.74092V7.99992C19.3941 7.99992 19.7842 8.07751 20.1482 8.22828C20.5122 8.37904 20.8429 8.60002 21.1215 8.8786C21.4001 9.15717 21.6211 9.48789 21.7718 9.85187C21.9226 10.2158 22.0002 10.606 22.0002 10.9999C22.0002 11.3939 21.9226 11.784 21.7718 12.148C21.6211 12.5119 21.4001 12.8427 21.1215 13.1212C20.8429 13.3998 20.5122 13.6208 20.1482 13.7716C19.7842 13.9223 19.3941 13.9999 19.0002 13.9999V16.9999C19.0002 18.6479 17.1192 19.5889 15.8002 18.5999L13.7402 17.0539C12.639 16.2283 11.3569 15.677 10.0002 15.4459V18.2899C10.0003 18.9437 9.76407 19.5754 9.33507 20.0687C8.90608 20.562 8.31322 20.8836 7.66579 20.9742C7.01836 21.0648 6.35999 20.9183 5.81205 20.5618C5.26412 20.2052 4.86354 19.6626 4.68417 19.0339L3.11417 13.5379C2.54919 12.8707 2.18151 12.0591 2.05246 11.1944C1.92341 10.3297 2.03811 9.44615 2.38366 8.64306C2.72921 7.83996 3.29192 7.14916 4.00853 6.64831C4.72513 6.14747 5.56724 5.85643 6.44017 5.80792L9.45817 5.63992C10.9348 5.55775 12.3708 5.12625 13.6482 4.38092L15.9922 3.01292C17.3262 2.23592 19.0002 3.19692 19.0002 4.74092ZM5.63417 15.0779L6.60717 18.4849C6.654 18.6498 6.75892 18.7922 6.90255 18.8858C7.04618 18.9794 7.21883 19.0179 7.38861 18.9941C7.55839 18.9704 7.71383 18.886 7.82624 18.7565C7.93865 18.6271 8.00043 18.4614 8.00017 18.2899V15.2799L6.44017 15.1929C6.1687 15.1779 5.89903 15.1394 5.63417 15.0779ZM17.0002 4.74092L14.6552 6.10992C13.2305 6.94036 11.642 7.4502 10.0002 7.60392V13.4229C11.7872 13.6689 13.4882 14.3659 14.9402 15.4539L17.0002 16.9999V4.74092ZM8.00017 7.72392L6.55017 7.80392C5.87562 7.84116 5.23954 8.12994 4.76749 8.61324C4.29544 9.09654 4.02173 9.73925 4.00038 10.4145C3.97903 11.0897 4.2116 11.7484 4.65217 12.2606C5.09275 12.7728 5.70932 13.1011 6.38017 13.1809L6.55017 13.1959L8.00017 13.2759V7.72392ZM19.0002 9.99992V11.9999C19.2551 11.9996 19.5002 11.902 19.6855 11.7271C19.8709 11.5521 19.9824 11.313 19.9973 11.0585C20.0123 10.8041 19.9295 10.5535 19.7659 10.3581C19.6023 10.1626 19.3703 10.037 19.1172 10.0069L19.0002 9.99992Z" fill="#27BBF9" />
                        </svg>
                    </div>
                    <p>{text}</p>
                </div>
                <style>{`
                /* styles.css or styles.scss */
                .announcement-card {
                    background-color: #fff;
                    border: 1px solid #ccc;
                    border-radius: 8px;
                    padding: 16px;
                    margin-top: 0px;
                    margin-bottom: 12px;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    display: flex;
                    align-items: center;
                    justify-content: center; /* Center horizontally */
                    height: 100%; /* Make the card full height */
                }

                .announcement-icon {
                  margin-right: 10px;
                }

                .announcement-card p {
                  font-weight: bold;
                  margin: 0px;
                  padding-bottom: 5px;
                  padding-right: 12px;
                }
            `}</style>
            </>
        );
    };

    return (
        <div>
            <LoadingOverlay show={isLoading} inBootstrapColumn={true} />
            <AnnouncementCard text={`Enhanced Vacant Unit Management is now Available for ${propertyType} Clients`} />
            {canSeeManage &&
                <div className="card-header">
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex' }}>
                            <form>
                                <input type="file" id="myFile" name="filename" accept={".csv"} onChange={(e) => { handleCSV(e.target.files) }}  disabled={isUser}/>
                                <Button
                                    text="Submit"
                                    addlClassName="btn-primary"
                                    onClick={() => {
                                        submitCSV(props.propertyId, uploadFile);
                                    }}
                                    disabled={canNotEdit}
                                />
                            </form>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <Button
                                text="Add"
                                addlClassName="btn-primary"
                                onClick={() => {
                                    toggleAdd();
                                    setEditUnit(undefined);
                                    setNewUnit({
                                        ...newUnit,
                                        property_unit_type: activeTab === "1" ? 0 : 1
                                    })
                                }}
                                disabled={canNotEdit}
                            />
                            <ButtonGroup>
                                <Dropdown isOpen={dropdownOpen} toggle={() => {if (!canNotEdit) {toggleDrop();}}}>
                                    <DropdownToggle className='btn-primary font-weight-bold' caret disabled={canNotEdit}>
                                        Download
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem onClick={() => downloadTemplate()} disabled={canNotEdit}>Template</DropdownItem>
                                        <DropdownItem onClick={() => downloadUnits()} disabled={canNotEdit}>Units</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </ButtonGroup>
                        </div>
                    </div>
                </div>
            }
            <div>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={activeTab === "1" ? "active" : ""}
                            onClick={() => {
                                setActiveTab("1")
                                resetFilterOnly()
                            }}
                        >
                            <Head1Text text='Property Units' />
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={activeTab === "2" ? "active" : ""}
                            onClick={() => {
                                setActiveTab("2")
                                resetFilterOnly()
                            }}
                        >
                            <Head1Text text={'Common Area'} />
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px', paddingBottom: '10px' }}>
                            <div className='col-6 p-0'>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                                    <Input
                                        type="text"
                                        placeholder='Search'
                                        disabled={canNotEdit}
                                        onChange={(e) => {
                                            const str = e.target.value.toLowerCase();
                                            setSearchText(str);
                                        }}
                                    />
                                    {/* {searchText && searchText !== '' &&
                                    <label onClick={() => {
                                        setSearchText('');
                                    }} style={{
                                        cursor: 'pointer',
                                        color: '#27bbf9',
                                        marginLeft: '5px',
                                        marginBottom: 0,
                                    }}> clear </label>
                                } */}
                                    <div style={{ width: '20px' }}></div>
                                    <p 
                                        onClick={!canNotEdit ? () => toggleFilter() : undefined}
                                        style={{
                                            fontWeight: 'bold', 
                                            color: canNotEdit ? 'grey' : ColorConstants.PrimaryColor, 
                                            margin: '0px', 
                                            cursor: canNotEdit ? 'not-allowed' : 'pointer',
                                            pointerEvents: canNotEdit ? 'none' : 'auto'  
                                        }}
                                    >
                                        Filter
                                    </p>
                            </div>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }} className='col-2 p-0'>
                                {!shouldDisableButton() && canSeeManage && (
                                    <Button
                                        text="Update Availability"
                                        addlClassName="btn-primary btn-sm"
                                        onClick={() => handleSyncPMS(props.propertyId)}
                                        disabled={canNotEdit}
                                    />
                                )}
                                {updateCountLoading && <span className="spinner-button"></span>}
                            </div>
                            {/* <div>
                                <ButtonGroup>
                                    <Button key={'zoom-in'} text={''} addlClassName={`btn-${view === 'TABLE' ? 'primary' : 'light'}`} suppressBottomMargin={true} onClick={() => setView('TABLE')}>
                                        <img
                                            className="fliter-icon"
                                            src={view === 'TABLE' ? ListViewWhiteIcon : ListViewIcon}
                                        />
                                    </Button>
                                    <Button
                                        key={'zoom-out'}
                                        text={''}
                                        addlClassName={`btn-${view === 'GRID' ? 'primary' : 'light'}`}
                                        suppressBottomMargin={true}
                                        onClick={() => setView('GRID')}
                                    >
                                        <img
                                            className="fliter-icon"
                                            src={view === 'GRID' ? GridViewWhiteIcon : GridViewIcon}
                                        />
                                    </Button>
                                </ButtonGroup>
                            </div> */}
                        </div>
                        {
                        /* {
                            view === 'GRID' &&
                            <div className='row' style={{ paddingTop: '20px' }}>
                                {propertyList &&
                                    propertyList.filter((unit) => unit.property_unit_type !== 1).map((unit, i) => {
                                        return (<UnitManagementCard hideFields={false} unit={unit} i={i} propInfo={propInfo} renderAvailableForTour={renderAvailableForTour} canSeeManage={canSeeManage} renderLockType={renderLockType} renderModelUnitSwitch={renderModelUnitSwitch} toggle={toggle} setDeletionUnitId={setDeletionUnitId} renderAccessEnabled={renderAccessEnabled} setEditUnit={setEditUnit} />)
                                    })
                                }
                            </div>
                        } */}
                        {
                            view === 'TABLE' && <UnitManagementTable
                                columns={[
                                    {
                                        key: 'buildingName',
                                        name: 'Building Name',
                                        width: 150
                                    },
                                    {
                                        key: 'pms_unit_display_name',
                                        name: 'Unit Number',
                                        width: 150,
                                        renderColumn: renderName
                                    },
                                    {
                                        key: 'floorPlanName',
                                        name: 'Floor Plan Name',
                                        width: 150
                                    },
                                    {
                                        key: 'floorPlanID',
                                        name: 'Floor Plan',
                                        width: 150
                                    },
                                    /* {
                                         key: 'pms_unit_id',
                                         name: 'PMS Unit ID',
                                         width: 100,
                                         renderColumn: renderUnitId
                                     },*/
                                    canSeeManage && {
                                        key: 'lock_type',
                                        name: 'Integration',
                                        renderColumn: renderLockType,
                                        width: 150,
                                    },
                                    {
                                        key: 'sqft',
                                        name: 'Sqft',
                                        width: 80
                                    },
                                    {
                                        key: 'bed',
                                        name: 'Bed',
                                        width: 80
                                    },
                                    {
                                        key: 'bath',
                                        name: 'Bath',
                                        width: 80
                                    },
                                    {
                                        key: 'floor',
                                        name: 'Floor',
                                        width: 80
                                    },
                                    {
                                        key: 'access_enabled',
                                        name: 'Available to Tour',
                                        width: 150,
                                        renderColumn: renderAccessEnabled
                                    },
                                    propertyType === "Yardi" && {
                                        key: 'available',
                                        name: 'Occupancy Status',
                                        width: 165,
                                        renderColumn: renderAvailableForTour,
                                    },
                                    propertyType === "Yardi" && {
                                        key: 'yardiLeaseStatus',
                                        name: 'Lease Status',
                                        width: 150,
                                        renderColumn: renderLeaseStatus,
                                    },
                                    propertyType === "Yardi" && {
                                        key: 'yardiRentReady',
                                        name: 'Rent Ready',
                                        width: 125,
                                        renderColumn: renderRentReady,
                                    },
                                    propertyType === "Entrata" && {
                                        key: 'entrataAvailabilityStatus',
                                        name: 'Availability Status',
                                        width: 200,
                                        renderColumn: renderEntrataAvailabilityStatus,
                                    },
                                    propertyType === "OneSite" && {
                                        key: 'onesiteVacant',
                                        name: 'Vacant',
                                        width: 125,
                                        renderColumn: renderOnesiteVacant,
                                    },
                                    propertyType === "OneSite" && {
                                        key: 'onesiteAvailable',
                                        name: 'Available',
                                        width: 125,
                                        renderColumn: renderOnesiteAvailable,
                                    },
                                    propertyType === "OneSite" && {
                                        key: 'onesiteMadeReady',
                                        name: 'Made Ready',
                                        width: 140,
                                        renderColumn: renderOnesiteMadeReady,
                                    },
                                    /*{
                                        key: 'sync',
                                        name: 'Sync',
                                        width: 80,
                                        renderColumn: renderAvailableSync,
                                        isHide: !propInfo.syncPropertyUnitsAvailability,
                                    },*/
                                    {
                                        key: 'Action',
                                        name: '',
                                        width: 300,
                                        renderColumn: renderAction
                                    },
                                ]}
                                data={propertyList.filter((unit) => unit.property_unit_type !== 1)}
                            />
                        }
                    </TabPane>
                    <TabPane tabId="2">
                        {/* {
                            view === 'GRID' &&
                            <div className='row' style={{ paddingTop: '20px' }}>
                                {propertyList &&
                                    propertyList.filter((unit) => unit.property_unit_type !== 0).map((unit, i) => {
                                        return (<UnitManagementCard hideFields={true} unit={unit} i={i} propInfo={propInfo} renderAvailableForTour={renderAvailableForTour} canSeeManage={canSeeManage} renderLockType={renderLockType} renderModelUnitSwitch={renderModelUnitSwitch} toggle={toggle} setDeletionUnitId={setDeletionUnitId} renderAccessEnabled={renderAccessEnabled} setEditUnit={setEditUnit} />)
                                    })
                                }
                            </div>
                        } */}
                        {
                            view === 'TABLE' &&
                            <UnitManagementTable
                                columns={[
                                    {
                                        key: 'pms_unit_display_name',
                                        name: 'Name',
                                        width: 150,
                                        renderColumn: renderName
                                    },
                                    {
                                        key: 'pms_unit_id',
                                        name: 'ID',
                                        width: 150,
                                        renderColumn: renderUnitId
                                    },
                                    canSeeManage && {
                                        key: 'lock_type',
                                        name: 'Integration',
                                        renderColumn: renderLockType,
                                        width: 260,
                                    },
                                    {
                                        key: 'access_enabled',
                                        name: 'Access Enabled',
                                        width: 150,
                                        renderColumn: renderAccessEnabled
                                    },
                                    /* {
                                         key: 'PMS Unit Status',
                                         name: 'PMS Unit Status',
                                         width: 120,
                                         renderColumn: renderAvailableForTour,
                                         isHide: !propInfo.syncPropertyUnitsAvailability,
                                     }, */
                                    /*{
                                        key: 'sync',
                                        name: 'Sync',
                                        width: 80,
                                        renderColumn: renderAvailableSync,
                                        isHide: !propInfo.syncPropertyUnitsAvailability,
                                    },*/
                                    {
                                        key: 'Action',
                                        name: '',
                                        width: 200,
                                        renderColumn: renderAction
                                    },
                                ]}
                                data={propertyList.filter((unit) => unit.property_unit_type === 1)}
                            />
                        }
                    </TabPane>
                </TabContent>
            </div>
            <div>
                <Modal
                    isOpen={editModal}
                    toggle={toggle}
                    centered={true}
                    size='lg'
                >
                    <ModalHeader toggle={toggle}>Edit Information</ModalHeader>
                    <ModalBody style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {editUnit &&
                            <div style={{ width: "100%" }}>
                                <div className='row'>
                                    <FormGroup className="col-12">
                                        <Label for="displayName">
                                            Name
                                        </Label>
                                        <Input
                                            id="displayName"
                                            type="text"
                                            disabled={!canSeeManage}
                                            value={editUnit.pms_unit_display_name}
                                            placeholder={editUnit.pms_unit_display_name}
                                            onChange={(e) =>
                                                setEditUnit(
                                                    {
                                                        ...editUnit,
                                                        pms_unit_display_name: e.target.value
                                                    }
                                                )
                                            }
                                        />
                                    </FormGroup>
                                </div>
                                <div className='row'>
                                    {activeTab === "1" && <FormGroup className="col-6">
                                        <Label for="unitType">
                                            Unit Type
                                        </Label>
                                        <Input
                                            id="unitType"
                                            type="text"
                                            disabled={!canSeeManage}
                                            value={editUnit.unit_type}
                                            placeholder={editUnit.unit_type}
                                            onChange={(e) =>
                                                setEditUnit(
                                                    {
                                                        ...editUnit,
                                                        unit_type: e.target.value
                                                    }
                                                )
                                            }
                                        />
                                    </FormGroup>}
                                    <FormGroup className={activeTab === "1" ? "col-6" : "col-12"}>
                                        <Label for="pms_unit_id">
                                            {activeTab === "1" ? "PMS Unit Id" : "Id"}
                                        </Label>
                                        <Input
                                            id="pms_unit_id"
                                            type="text"
                                            disabled={!canSeeManage}
                                            value={editUnit.pms_unit_id}
                                            placeholder={editUnit.pms_unit_id}
                                            onChange={(e) =>
                                                setEditUnit(
                                                    {
                                                        ...editUnit,
                                                        pms_unit_id: e.target.value
                                                    }
                                                )
                                            }
                                        />
                                    </FormGroup>
                                </div>
                                {/* <div className='row'>
                                    <FormGroup className='col-6'>
                                        <Label for="lockType">
                                            Integration Type
                                        </Label>
                                        <select
                                            disabled={!canSeeManage}
                                            value={editUnit.lock_type}
                                            className='form-control'
                                            onChange={event => setEditUnit({
                                                ...editUnit,
                                                lock_type: Number(event.target.value)
                                            })}
                                        >
                                            <option value="0"></option>
                                            <option value="1">Smart Rent</option>
                                            <option value="2">Butterfly MX</option>
                                            <option value="3">Stratis</option>
                                            <option value="4">Latch</option>
                                            <option value="5">GeoKey</option>
                                            <option value="6">AmazonKey</option>
                                            <option value="7">BrivoKey</option>
                                        </select>
                                    </FormGroup>
                                    <FormGroup className='col-6'>
                                        <Label for="smartrent">
                                            Integration Id
                                        </Label>
                                        <Input
                                            id="smartrent"
                                            type="text"
                                            disabled={!canSeeManage}
                                            value={editUnit.smartRentRemoteUnitId}
                                            placeholder={editUnit.smartRentRemoteUnitId.toString()}
                                            onChange={(e) =>
                                                setEditUnit(
                                                    {
                                                        ...editUnit,
                                                        smartRentRemoteUnitId: e.target.value
                                                    }
                                                )
                                            }
                                        />
                                    </FormGroup>
                                </div> */}
                                <div className='row'>
                                    <FormGroup className={activeTab === "1" ? "col-6" : "col-12"}>
                                        <Label for="propertyunittype">
                                            Classification
                                        </Label>
                                        <select
                                            // disabled={!canSeeManage}
                                            disabled={true}
                                            value={editUnit.property_unit_type}
                                            className='form-control'
                                            onChange={event => setEditUnit({
                                                ...editUnit,
                                                property_unit_type: Number(event.target.value)
                                            })}
                                        >
                                            <option value="0">Unit</option>
                                            <option value="1">Common Area</option>
                                        </select>
                                    </FormGroup>
                                    {activeTab === "1" && <FormGroup className='col-6'>
                                        <Label for="floor">
                                            Floor
                                        </Label>
                                        <Input
                                            id="floor"
                                            disabled={!canSeeManageFloor}
                                            value={editUnit.floor != null ? editUnit.floor : ''}
                                            placeholder={editUnit.floor != null ? editUnit.floor : 'Enter floor'}
                                            onChange={(e) =>
                                                setEditUnit({
                                                    ...editUnit,
                                                    floor: e.target.value
                                                })
                                            }
                                        />
                                    </FormGroup>}
                                </div>
                                {activeTab === "1" && <div className='row'>
                                    <FormGroup className='col-6'>
                                        <Label for="bed">
                                            Bed
                                        </Label>
                                        <Input
                                            id="bed"
                                            disabled={!canSeeManage}
                                            type="number"
                                            value={editUnit.bed.toString()}
                                            placeholder={editUnit.bed.toString()}
                                            onChange={(e) =>
                                                setEditUnit(
                                                    {
                                                        ...editUnit,
                                                        bed: Number(e.target.value)
                                                    }
                                                )
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup className='col-6'>
                                        <Label for="bath">
                                            Bath
                                        </Label>
                                        <Input
                                            id="bath"
                                            disabled={!canSeeManage}
                                            type="number"
                                            value={editUnit.bath.toString()}
                                            placeholder={editUnit.bath.toString()}
                                            onChange={(e) =>
                                                setEditUnit(
                                                    {
                                                        ...editUnit,
                                                        bath: Number(e.target.value)
                                                    }
                                                )
                                            }
                                        />
                                    </FormGroup>
                                </div>}
                                {activeTab === "1" && <div className='row'>
                                    <FormGroup className='col-6'>
                                        <Label for="sqft">
                                            Square Feet
                                        </Label>
                                        <Input
                                            id="sqft"
                                            type="number"
                                            disabled={!canSeeManage}
                                            value={editUnit.sqft}
                                            placeholder={editUnit.sqft.toString()}
                                            onChange={(e) =>
                                                setEditUnit(
                                                    {
                                                        ...editUnit,
                                                        sqft: Number(e.target.value)
                                                    }
                                                )
                                            }
                                        />
                                    </FormGroup>
                                    <FormGroup className='col-6'>
                                        <Label for="startingPrice">
                                            Starting Price
                                        </Label>
                                        <Input
                                            id="startingPrice"
                                            type="number"
                                            disabled={!canSeeManage}
                                            value={editUnit.starting_price}
                                            placeholder={editUnit.starting_price.toString()}
                                            onChange={(e) =>
                                                setEditUnit(
                                                    {
                                                        ...editUnit,
                                                        starting_price: Number(e.target.value)
                                                    }
                                                )
                                            }
                                        />
                                    </FormGroup>
                                </div>}
                                {/* <FormGroup>
                                    <Label for="beaconMajor">
                                        Beacon ID
                                    </Label>
                                    <Input
                                        id="beaconMajor"
                                        type="number"
                                        disabled={!isAdmin}
                                        value={editUnit.beaconMajor}
                                        placeholder={editUnit.beaconMajor.toString()}
                                        onChange={(e) =>
                                            setEditUnit(
                                                {
                                                    ...editUnit,
                                                    beaconMajor: Number(e.target.value)
                                                }
                                            )
                                        }
                                    />
                                </FormGroup> */}
                                <div className='row'>
                                    { editModal && accessTypes.length > 0 && <div className='col-6'>
                                        <FormGroup>
                                            <Label for="lockType">
                                                Access
                                            </Label>
                                            <select
                                                disabled={!canSeeManage}
                                                value={editUnit.lock_type}
                                                className='form-control'
                                                onChange={event => {
                                                    setIntegrationDrop([])
                                                    if(Number(event.target.value) != 0){
                                                        setIntegrationLoading(true)
                                                        getIntegrationIds(Number(event.target.value));
                                                    }
                                                    setEditUnit({
                                                        ...editUnit,
                                                        keyCafeUnitKeys: [],
                                                        lock_type: Number(event.target.value),
                                                        smartRentRemoteUnitId: '',
                                                    })
                                                    if(errText === accessSelectionErr){
                                                        setErrText('')
                                                    }

                                                }}
                                            >
                                                 <option value={0}>Select</option>
                                                {
                                                    accessTypes.map((access)=>{
                                                        return <option value={access.id}>{access.option}</option>
                                                    })
                                                }
                                            </select>
                                        </FormGroup>
                                        <FormGroup style={{ position: 'relative' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            { editUnit.lock_type === 9 ? <MinimalMultiSelect 
                                                heading={editUnit.keyCafeUnitKeys.map((group: any) => group.keyId).length>0? editUnit.keyCafeUnitKeys.map((group: any) => group.keyId).length + (editUnit.keyCafeUnitKeys.map((group: any) => group.keyId).length ===1? ' Key Selected': ' Keys Selected') : 'Select Keys'}
                                                listItems={integrationDrop.map((group: any) => ({ name: group.keyName, id: group.keyId }))} 
                                                selectedIds={editUnit.keyCafeUnitKeys.map((group: any) => group.keyId)}
                                                setSelectedIds={function (ids: any[]): void {
                                                        const selectedKeys = integrationDrop.filter((key: any) => ids.includes(key.keyId));
                                                        setEditUnit({
                                                            ...editUnit,
                                                            keyCafeUnitKeys: selectedKeys
                                                        })
                                                    }}
                                                /> :
                                                <SearchableDropdownClear
                                                        onBlur={(lock_info: any) => {
                                                            if(lock_info && editUnit.lock_type === 8){
                                                                activateMasterLock(props.propertyId, lock_info).then(async result => {
                                                                    if (result.data && result.data.toString() === 'Activation failed') {
                                                                    setErrText('Please provide a valid lock')
                                                                    }
                                                                    else {
                                                                    setLockSubmitted(true)
                                                                    }
                                                                });
                                                            }
                                                            setEditUnit({
                                                                    ...editUnit,
                                                                    smartRentRemoteUnitId: lock_info? lock_info.toString() : '', // Set to empty if null
                                                                });
                                                        }}
                                                        handleInputChange={(lock_info: any)=>{
                                                            setEditUnit({
                                                                ...editUnit,
                                                                smartRentRemoteUnitId: lock_info? lock_info.toString() : '', // Set to empty if null
                                                            });
                                                            if(lock_info){
                                                                setErrText('')
                                                            }
                                                        }}
                                                        hideNoResultsFound={true}
                                                        heading={integrationLoading ? "Loading..." : "Integration Id"}
                                                        listItems={integrationDrop.sort((a: any, b: any) => {
                                                        const nameA = a.unit_name.toLowerCase();
                                                        const nameB = b.unit_name.toLowerCase();
                                            
                                                        // Numeric and alphabetical sort
                                                        return nameA.localeCompare(nameB, undefined, {
                                                            numeric: true,
                                                            sensitivity: 'base',
                                                        });
                                                    }).map((integration: any) => ({
                                                                name: `${integration.unit_name} : ${integration.unit_id}`,
                                                                value: integration.unit_id,
                                                            }))}
                                                        selectedId={editUnit.smartRentRemoteUnitId}
                                                        setSelectedId={(id: number | null) => {
                                                            setEditUnit({
                                                                ...editUnit,
                                                                smartRentRemoteUnitId: id? id.toString() : '', // Set to empty if null
                                                            });
                                                        }}
                                                    />}
                                                <p style={{ color: 'red' }}>{errText}</p>
                                            </div>
                                        </FormGroup>
                                    </div>}
                                    <div className='col-6'>
                                     <FormGroup>
                                            <Label for="beaconMajor">
                                                Beacon ID
                                            </Label>
                                            <Input
                                                id="beaconMajor"
                                                type="number"
                                                disabled={!isAdmin}
                                                value={editUnit.beaconMajor}
                                                placeholder={editUnit.beaconMajor.toString()}
                                                onChange={(e) =>
                                                    setEditUnit(
                                                        {
                                                            ...editUnit,
                                                            beaconMajor: Number(e.target.value)
                                                        }
                                                    )
                                                }
                                            />
                                        </FormGroup> 
                                    </div>
                                </div>
                                <div className='row w-100 m-0'>
                                    <div className='col p-0'>
                                        <Label for="description">
                                            Directions
                                        </Label>
                                        <RichTextEditor
                                            value={editUnit.directions}
                                            onChange={(value: any) => {
                                                setEditUnit(
                                                    {
                                                        ...editUnit,
                                                        directions: value
                                                    }
                                                )
                                            }

                                            }
                                        />
                                    </div>
                                </div>
                                <div className='row mt-3'>
                                    {activeTab === "1" && <div style={{ display: "flex", alignItems: "center" }} className='col-6'>
                                        <span style={{ marginRight: "10px" }}>Model Unit</span>
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                role="switch"
                                                checked={editUnit.model_unit}
                                                onChange={() => {
                                                    setEditUnit(
                                                        {
                                                            ...editUnit,
                                                            model_unit: !editUnit.model_unit
                                                        }
                                                    )
                                                }
                                                }
                                            />
                                            <span className="slider round" />
                                        </label>
                                    </div>}
                                   
                                    <div style={{ display: "flex", alignItems: "center" }} className='col-6'>
                                        <span style={{ marginRight: "10px" }}>Available to Tour</span>
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                role="switch"
                                                checked={editUnit.access_enabled}
                                                onChange={() => {

                                                    let change = true

                                                    if (propertyType === "Entrata" && editUnit.property_unit_type == 0 && !editUnit.access_enabled && editUnit.entrataAvailabilityStatus != null && editUnit.entrataAvailabilityStatus !== "Vacant Ready (Available)") {
                                                        change = false
                                                        setShowOccupied(true);
                                                    }

                                                    else if (propertyType === "OneSite" && editUnit.property_unit_type == 0 && !editUnit.access_enabled && (!editUnit.onesiteVacant || !editUnit.onesiteAvailable || !editUnit.onesiteMadeReady)) {
                                                        change = false
                                                        setShowOccupied(true);
                                                    }

                                                    else if (propertyType === "Yardi" && editUnit.property_unit_type == 0 && !editUnit.access_enabled && !editUnit.available) {
                                                        change = false
                                                        setShowOccupied(true);
                                                    } else {
                                                        setShowOccupied(false);
                                                    }

                                                    if (change) {
                                                        if (editUnit.property_unit_type == 0 && !editUnit.access_enabled) {
                                                            setShowTourEnableDetails(editUnit)
                                                        } else {
                                                            setEditUnit(
                                                                {
                                                                    ...editUnit,
                                                                    access_enabled: !editUnit.access_enabled,
                                                                }
                                                            )
                                                        }
                                                    }

                                                }
                                                }
                                            />
                                            <span className="slider round" />
                                        </label>
                                    </div>
                                    
                                </div>
                                            
                                <div className='row mt-3'>
                                    {/* <div style={{ display: "flex", alignItems: "center" }} className='col-6'>
                                        <span style={{ marginRight: "10px" }}>Available to Lease </span>
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                role="switch"
                                                checked={editUnit.available}
                                                onChange={() => {
                                                    setEditUnit(
                                                        {
                                                            ...editUnit,
                                                            available: !editUnit.available,
                                                        }
                                                    )
                                                }
                                                }
                                            />
                                            <span className="slider round" />
                                        </label>
                                    </div> */}
                                    {/* {propInfo && propInfo.syncPropertyUnitsAvailability &&
                                        <div style={{ display: "flex", alignItems: "center" }} className='col-6'>
                                            <span style={{ marginRight: "10px" }}>Sync </span>
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    role="switch"
                                                    checked={editUnit.syncUnitAvailability ? editUnit.syncUnitAvailability : false}
                                                    onChange={() => {
                                                        setEditUnit(
                                                            {
                                                                ...editUnit,
                                                                syncUnitAvailability: !editUnit.syncUnitAvailability,
                                                            }
                                                        )
                                                    }
                                                    }
                                                />
                                                <span className="slider round" />
                                            </label>
                                        </div>
                                    } */}
                                </div>
                            </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button text="Cancel" addlClassName="btn-secondary" onClick={toggle} />
                        {' '}
                        <Button text="Confirm" addlClassName="btn-primary" onClick={() => {
                            if(editUnit && editUnit.lock_type !==null && editUnit.lock_type !==0 && editUnit.smartRentRemoteUnitId === "" && editUnit.keyCafeUnitKeys.length === 0){
                                setErrText(integrationIdErr)
                            } else if(editUnit && (editUnit.lock_type == null || editUnit.lock_type == 0) && editUnit.smartRentRemoteUnitId !== ""){
                                setErrText(accessSelectionErr)
                            } else {
                                toggle();
                                if (editUnit) {
                                    let submitEditUnit: propertyUnits = editUnit
    
                                    // making sure edit common area has default values
                                    if (activeTab === "2") {
                                        submitEditUnit = {
                                            ...submitEditUnit,
                                            unit_type: "",
                                            floor: "",
                                            bed: 0,
                                            bath: 0,
                                            sqft: 0,
                                            starting_price: 0,
                                            model_unit: false
                                        }
                                    }

                                    if(submitEditUnit.lock_type!=8){
                                        handleEdit(submitEditUnit);
                                        toggle();
                                    } else{
                                        setConfirmEditState(true)
                                        editData(submitEditUnit)
                                    }
                                }
                           
                        }}} />
                    </ModalFooter>
                </Modal>
            </div>
            <Modal
                isOpen={filterModal}
                toggle={toggleFilter}
                centered={true}
                size="lg"
            >
                <ModalHeader toggle={toggleFilter}>Unit Filter</ModalHeader>
                <ModalBody>
                    <div className='p-10'>
                        <FormGroup>
                            <div>
                                <Label for="lockType">
                                    Available to Tour
                                </Label>
                            </div>
                            <ButtonGroup>
                                <Button key={'availability-all'} text={''} addlClassName={`${filter.accessEnabled === 0 ? 'btn-primary' : 'btn-light'} btn-sm`} suppressBottomMargin={true} onClick={() => {
                                    setFilter({
                                        ...filter, ...{
                                            accessEnabled: 0
                                        }
                                    })
                                }}>
                                    ALL
                                </Button>
                                <Button
                                    key={'availability-vaccant'}
                                    text={''}
                                    addlClassName={`${filter.accessEnabled === 1 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                accessEnabled: 1
                                            }
                                        })
                                    }}
                                >
                                    Yes
                                </Button>
                                <Button
                                    key={'availability-occupied'}
                                    text={''}
                                    addlClassName={`${filter.accessEnabled === 2 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                accessEnabled: 2
                                            }
                                        })
                                    }}
                                >
                                    No
                                </Button>
                            </ButtonGroup>
                        </FormGroup>
                        {propertyType === "Yardi" && <FormGroup>
                            <div>
                                <Label for="lockType">
                                    Rent Ready
                                </Label>
                            </div>
                            <ButtonGroup>
                                <Button key={'rent-ready-all'} text={''} addlClassName={`${filter.rentReady === 0 ? 'btn-primary' : 'btn-light'} btn-sm`} suppressBottomMargin={true} onClick={() => {
                                    setFilter({
                                        ...filter, ...{
                                            rentReady: 0
                                        }
                                    })
                                }}>
                                    ALL
                                </Button>
                                <Button
                                    key={'rent-ready-vaccant'}
                                    text={''}
                                    addlClassName={`${filter.rentReady === 1 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                rentReady: 1
                                            }
                                        })
                                    }}
                                >
                                    True
                                </Button>
                                <Button
                                    key={'rent-ready-occupied'}
                                    text={''}
                                    addlClassName={`${filter.rentReady === 2 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                rentReady: 2
                                            }
                                        })
                                    }}
                                >
                                    False
                                </Button>
                            </ButtonGroup>
                        </FormGroup>}
                        {propertyType === "Yardi" && <FormGroup>
                            <div>
                                <Label for="lockType">
                                    Occupany Status
                                </Label>
                            </div>
                            <ButtonGroup>
                                <Button key={'occupancy-all'} text={''} addlClassName={`${filter.available === 0 ? 'btn-primary' : 'btn-light'} btn-sm`} suppressBottomMargin={true} onClick={() => {
                                    setFilter({
                                        ...filter, ...{
                                            available: 0
                                        }
                                    })
                                }}>
                                    ALL
                                </Button>
                                <Button
                                    key={'occupancy-vaccant'}
                                    text={''}
                                    addlClassName={`${filter.available === 1 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                available: 1
                                            }
                                        })
                                    }}
                                >
                                    Vacant
                                </Button>
                                <Button
                                    key={'occupancy-occupied'}
                                    text={''}
                                    addlClassName={`${filter.available === 2 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                available: 2
                                            }
                                        })
                                    }}
                                >
                                    Occupied
                                </Button>
                            </ButtonGroup>
                        </FormGroup>}
                        {propertyType === "Yardi" && <FormGroup>
                            <div>
                                <Label for="lockType">
                                    Lease Status
                                </Label>
                            </div>
                            <ButtonGroup>
                                <Button key={'lease-status-all'} text={''} addlClassName={`${filter.leaseStatus === 0 ? 'btn-primary' : 'btn-light'} btn-sm`} suppressBottomMargin={true} onClick={() => {
                                    setFilter({
                                        ...filter, ...{
                                            leaseStatus: 0
                                        }
                                    })
                                }}>
                                    ALL
                                </Button>
                                <Button
                                    key={'lease-status-leased'}
                                    text={''}
                                    addlClassName={`${filter.leaseStatus === 1 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                leaseStatus: 1
                                            }
                                        })
                                    }}
                                >
                                    Leased
                                </Button>
                                <Button
                                    key={'lease-status-on-notice'}
                                    text={''}
                                    addlClassName={`${filter.leaseStatus === 2 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                leaseStatus: 2
                                            }
                                        })
                                    }}
                                >
                                    On Notice
                                </Button>
                                <Button
                                    key={'lease-status-available'}
                                    text={''}
                                    addlClassName={`${filter.leaseStatus === 3 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                leaseStatus: 3
                                            }
                                        })
                                    }}
                                >
                                    Available
                                </Button>
                                <Button
                                    key={'lease-status-leased-reserved'}
                                    text={''}
                                    addlClassName={`${filter.leaseStatus === 4 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                leaseStatus: 4
                                            }
                                        })
                                    }}
                                >
                                    Leased Reserved
                                </Button>
                                <Button
                                    key={'lease-status-other'}
                                    text={''}
                                    addlClassName={`${filter.leaseStatus === 5 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                leaseStatus: 5
                                            }
                                        })
                                    }}
                                >
                                    Other
                                </Button>
                            </ButtonGroup>
                        </FormGroup>}
                        {propertyType === "Entrata" && <FormGroup>
                            <div>
                                <Label for="lockType">
                                    Availability Status
                                </Label>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <Button key={'entrata-status-all'} text={''} addlClassName={`${filter.entrataAvailabilityStatus === 0 ? 'btn-primary' : 'btn-light'} btn-sm`} suppressBottomMargin={true} onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                entrataAvailabilityStatus: 0
                                            }
                                        })
                                    }}>
                                        ALL
                                    </Button>
                                    <Button
                                        key={'entrata-status-vacant-available'}
                                        text={''}
                                        addlClassName={`${filter.entrataAvailabilityStatus === 1 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                        suppressBottomMargin={true}
                                        onClick={() => {
                                            setFilter({
                                                ...filter, ...{
                                                    entrataAvailabilityStatus: 1
                                                }
                                            })
                                        }}
                                    >
                                        Vacant Ready (Available)
                                    </Button>
                                    <Button
                                        key={'entrata-status-vacant-unavailable'}
                                        text={''}
                                        addlClassName={`${filter.entrataAvailabilityStatus === 2 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                        suppressBottomMargin={true}
                                        onClick={() => {
                                            setFilter({
                                                ...filter, ...{
                                                    entrataAvailabilityStatus: 2
                                                }
                                            })
                                        }}
                                    >
                                        Vacant Ready (Unavailable)
                                    </Button>
                                </div>
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <Button
                                        key={'entrata-status-vacant-not-unavailable'}
                                        text={''}
                                        addlClassName={`${filter.entrataAvailabilityStatus === 3 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                        suppressBottomMargin={true}
                                        onClick={() => {
                                            setFilter({
                                                ...filter, ...{
                                                    entrataAvailabilityStatus: 3
                                                }
                                            })
                                        }}
                                    >
                                        Vacant Not Ready (Unavailable)
                                    </Button>
                                    <Button
                                        key={'entrata-status-vacant-not-available'}
                                        text={''}
                                        addlClassName={`${filter.entrataAvailabilityStatus === 4 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                        suppressBottomMargin={true}
                                        onClick={() => {
                                            setFilter({
                                                ...filter, ...{
                                                    entrataAvailabilityStatus: 4
                                                }
                                            })
                                        }}
                                    >
                                        Vacant Not Ready (Available)
                                    </Button>
                                    <Button
                                        key={'entrata-status-notice-unavailable'}
                                        text={''}
                                        addlClassName={`${filter.entrataAvailabilityStatus === 5 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                        suppressBottomMargin={true}
                                        onClick={() => {
                                            setFilter({
                                                ...filter, ...{
                                                    entrataAvailabilityStatus: 5
                                                }
                                            })
                                        }}
                                    >
                                        On Notice (Unavailable)
                                    </Button>
                                </div>
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <Button
                                        key={'entrata-status-notice-available'}
                                        text={''}
                                        addlClassName={`${filter.entrataAvailabilityStatus === 6 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                        suppressBottomMargin={true}
                                        onClick={() => {
                                            setFilter({
                                                ...filter, ...{
                                                    entrataAvailabilityStatus: 6
                                                }
                                            })
                                        }}
                                    >
                                        On Notice (Available)
                                    </Button>
                                    <Button
                                        key={'entrata-status-occupied-unavailable'}
                                        text={''}
                                        addlClassName={`${filter.entrataAvailabilityStatus === 7 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                        suppressBottomMargin={true}
                                        onClick={() => {
                                            setFilter({
                                                ...filter, ...{
                                                    entrataAvailabilityStatus: 7
                                                }
                                            })
                                        }}
                                    >
                                        Occupied (Unavailable)
                                    </Button>
                                </div>
                            </div>
                        </FormGroup>}
                        {propertyType === "OneSite" && <FormGroup>
                            <div>
                                <Label for="lockType">
                                    Vacant
                                </Label>
                            </div>
                            <ButtonGroup>
                                <Button key={'onesite-vacant-all'} text={''} addlClassName={`${filter.onesiteVacant === 0 ? 'btn-primary' : 'btn-light'} btn-sm`} suppressBottomMargin={true} onClick={() => {
                                    setFilter({
                                        ...filter, ...{
                                            onesiteVacant: 0
                                        }
                                    })
                                }}>
                                    ALL
                                </Button>
                                <Button
                                    key={'onesite-vacant-true'}
                                    text={''}
                                    addlClassName={`${filter.onesiteVacant === 1 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                onesiteVacant: 1
                                            }
                                        })
                                    }}
                                >
                                    True
                                </Button>
                                <Button
                                    key={'onesite-vacant-false'}
                                    text={''}
                                    addlClassName={`${filter.onesiteVacant === 2 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                onesiteVacant: 2
                                            }
                                        })
                                    }}
                                >
                                    False
                                </Button>
                            </ButtonGroup>
                        </FormGroup>}
                        {propertyType === "OneSite" && <FormGroup>
                            <div>
                                <Label for="lockType">
                                    Available
                                </Label>
                            </div>
                            <ButtonGroup>
                                <Button key={'onesite-available-all'} text={''} addlClassName={`${filter.onesiteAvailable === 0 ? 'btn-primary' : 'btn-light'} btn-sm`} suppressBottomMargin={true} onClick={() => {
                                    setFilter({
                                        ...filter, ...{
                                            onesiteAvailable: 0
                                        }
                                    })
                                }}>
                                    ALL
                                </Button>
                                <Button
                                    key={'onesite-available-true'}
                                    text={''}
                                    addlClassName={`${filter.onesiteAvailable === 1 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                onesiteAvailable: 1
                                            }
                                        })
                                    }}
                                >
                                    True
                                </Button>
                                <Button
                                    key={'onesite-available-false'}
                                    text={''}
                                    addlClassName={`${filter.onesiteAvailable === 2 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                onesiteAvailable: 2
                                            }
                                        })
                                    }}
                                >
                                    False
                                </Button>
                            </ButtonGroup>
                        </FormGroup>}
                        {propertyType === "OneSite" && <FormGroup>
                            <div>
                                <Label for="lockType">
                                    Made Ready
                                </Label>
                            </div>
                            <ButtonGroup>
                                <Button key={'onesite-made-ready-all'} text={''} addlClassName={`${filter.onesiteMadeReady === 0 ? 'btn-primary' : 'btn-light'} btn-sm`} suppressBottomMargin={true} onClick={() => {
                                    setFilter({
                                        ...filter, ...{
                                            onesiteMadeReady: 0
                                        }
                                    })
                                }}>
                                    ALL
                                </Button>
                                <Button
                                    key={'onesite-made-ready-true'}
                                    text={''}
                                    addlClassName={`${filter.onesiteMadeReady === 1 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                onesiteMadeReady: 1
                                            }
                                        })
                                    }}
                                >
                                    True
                                </Button>
                                <Button
                                    key={'onesite-made-ready-false'}
                                    text={''}
                                    addlClassName={`${filter.onesiteMadeReady === 2 ? 'btn-primary' : 'btn-light'} btn-sm`}
                                    suppressBottomMargin={true}
                                    onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                onesiteMadeReady: 2
                                            }
                                        })
                                    }}
                                >
                                    False
                                </Button>
                            </ButtonGroup>
                        </FormGroup>}
                        <div className='row pl-3' style={{ gap: '12px' }}>
                            <FormGroup>
                                <Label for="lockType">
                                    Bed
                                </Label>
                                <div className="def-number-input number-input safari_only">
                                    <button className="minus" onClick={() => {
                                        if (filter.bed > 0) {
                                            setFilter({
                                                ...filter, ...{
                                                    bed: filter.bed - 1
                                                }
                                            })
                                        }
                                    }}></button>
                                    <Input className="quantity" min="0" name="quantity" value={filter.bed} type="number" />
                                    <button className="plus" onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                bed: filter.bed + 1
                                            }
                                        })
                                    }}></button>
                                </div>
                                <p style={{ marginTop: 5, fontSize: 1, fontStyle: 'italic' }}> set '0' to get all </p>
                            </FormGroup>
                            <FormGroup>
                                <Label for="lockType">
                                    Bath
                                </Label>
                                <div className="def-number-input number-input safari_only">
                                    <button className="minus" onClick={() => {
                                        if (filter.bath > 0) {
                                            setFilter({
                                                ...filter, ...{
                                                    bath: filter.bath - 1
                                                }
                                            })
                                        }
                                    }}></button>
                                    <Input className="quantity" min="0" name="quantity" value={filter.bath} type="number" />
                                    <button className="plus" onClick={() => {
                                        setFilter({
                                            ...filter, ...{
                                                bath: filter.bath + 1
                                            }
                                        })
                                    }}></button>
                                </div>
                                <p style={{ marginTop: 5, fontSize: 1, fontStyle: 'italic' }}> set '0' to get all </p>
                            </FormGroup>
                            <FormGroup>
                                <Label for="lockType">
                                    Floor
                                </Label>
                                <div className="def-number-input number-input safari_only">
                                    <button className="minus" onClick={() => {
                                        if (parseInt(filter.floor || "0") > 0) {
                                            setFilter({
                                                ...filter, ...{
                                                    floor: `${parseInt(filter.floor || "0") - 1}`,
                                                }
                                            })
                                        }
                                    }}></button>
                                    <Input className="quantity" min="0" name="quantity" value={filter.floor} type="number" />
                                    <button className="plus"
                                        onClick={() => {
                                            setFilter({
                                                ...filter, ...{
                                                    floor: `${parseInt(filter.floor || "0") + 1}`,
                                                }
                                            })
                                        }}></button>
                                </div>
                                <p style={{ marginTop: 5, fontSize: 1, fontStyle: 'italic' }}> set '0' to get all </p>
                            </FormGroup>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button text="Cancel" addlClassName="btn-secondary" onClick={toggleFilter} />
                    {' '}
                    <Button text="Reset" addlClassName="btn-secondary" onClick={() => { resetFilter() }} />
                    {' '}
                    <Button text="Confirm" addlClassName="btn-primary" onClick={() => {
                        handleFilter(true);
                    }} />
                </ModalFooter>

            </Modal>
            <Modal
                isOpen={addModal}
                toggle={toggleAdd}
                centered={true}
                size='md'
            >
                <ModalHeader toggle={toggleAdd}>Create {activeTab === "1" ? "Unit" : "Common Area"}</ModalHeader>
                <ModalBody style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                    <div style={{ width: "100%" }}>
                        <div className='row'>
                            <FormGroup className='col-12'>
                                <Label for="displayName">
                                    Name
                                </Label>
                                <Input
                                    id="displayName"
                                    type="text"
                                    required
                                    onChange={(e) =>
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                pms_unit_display_name: e.target.value
                                            }
                                        )
                                    }
                                />
                            </FormGroup>
                        </div>
                        <div className='row'>
                            {activeTab === "1" && <FormGroup className='col-6'>
                                <Label for="unitType">
                                    Unit Type
                                </Label>
                                <Input
                                    id="unitType"
                                    type="text"
                                    onChange={(e) =>
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                unit_type: e.target.value
                                            }
                                        )
                                    }
                                />
                            </FormGroup>}
                            <FormGroup className={activeTab === "1" ? "col-6" : "col-12"}>
                                <Label for="pms_unit_id">
                                    {activeTab === "1" ? "PMS Unit Id" : "Id"}
                                </Label>
                                <Input
                                    id="pms_unit_id"
                                    type="text"
                                    onChange={(e) =>
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                pms_unit_id: e.target.value
                                            }
                                        )
                                    }
                                />
                            </FormGroup>
                        </div>
                        {/* <div className='row'>
                            <FormGroup className='col-6'>
                                <Label for="lockType">
                                    Integration Type
                                </Label>
                                <select
                                    className='form-control'
                                    onChange={event => setNewUnit({
                                        ...newUnit,
                                        lock_type: Number(event.target.value)
                                    })}
                                >
                                    <option value="0"></option>
                                    <option value="1">Smart Rent</option>
                                    <option value="2">Butterfly MX</option>
                                    <option value="3">Stratis</option>
                                    <option value="4">Latch</option>
                                    <option value="5">GeoKey</option>
                                    <option value="6">AmazonKey</option>
                                    <option value="7">BrivoKey</option>
                                </select>
                            </FormGroup>
                            <FormGroup className='col-6'>
                                <Label for="unitId">
                                    Integration Id
                                </Label>
                                <Input
                                    id="unitId"
                                    type="text"
                                    onChange={(e) =>
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                smartRentRemoteUnitId: e.target.value
                                            }
                                        )
                                    }
                                />
                            </FormGroup>
                        </div> */}
                        <div className='row'>
                            <FormGroup className={activeTab === "1" ? "col-6" : "col-12"}>
                                <Label for="propertyUnitType">
                                    Classification
                                </Label>
                                <select
                                    className='form-control'
                                    disabled={true}
                                    value={newUnit.property_unit_type}
                                    onChange={event => setNewUnit({
                                        ...newUnit,
                                        property_unit_type: Number(event.target.value)
                                    })}
                                >
                                    <option value="0">Unit</option>
                                    <option value="1">Common Area</option>
                                </select>
                            </FormGroup>
                            {activeTab === "1" && <FormGroup className='col-6'>
                                <Label for="floor">
                                    Floor
                                </Label>
                                <Input
                                    id="floor"
                                    onChange={(e) =>
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                floor: e.target.value
                                            }
                                        )
                                    }
                                />
                            </FormGroup>}
                        </div>
                        {activeTab === "1" && <div className='row'>
                            <FormGroup className='col-6'>
                                <Label for="bed">
                                    Bed
                                </Label>
                                <Input
                                    id="bed"
                                    type="number"
                                    onChange={(e) =>
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                bed: Number(e.target.value)
                                            }
                                        )
                                    }
                                />
                            </FormGroup>
                            <FormGroup className='col-6'>
                                <Label for="bath">
                                    Bath
                                </Label>
                                <Input
                                    id="bath"
                                    type="number"
                                    onChange={(e) =>
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                bath: Number(e.target.value)
                                            }
                                        )
                                    }
                                />
                            </FormGroup>
                        </div>}
                        {activeTab === "1" && <div className='row'>
                            <FormGroup className='col-6'>
                                <Label for="sqft">
                                    Square Feet
                                </Label>
                                <Input
                                    id="sqft"
                                    type="number"
                                    onChange={(e) =>
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                sqft: Number(e.target.value)
                                            }
                                        )
                                    }
                                />
                            </FormGroup>
                            <FormGroup className='col-6'>
                                <Label for="startingPrice">
                                    Starting Price
                                </Label>
                                <Input
                                    id="startingPrice"
                                    type="number"
                                    onChange={(e) =>
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                starting_price: Number(e.target.value)
                                            }
                                        )
                                    }
                                />
                            </FormGroup>
                        </div>}
                        {/* <FormGroup>
                            <Label for="beaconMajor">
                                Beacon ID
                            </Label>
                            <Input
                                id="beaconMajor"
                                type="number"
                                onChange={(e) =>
                                    setNewUnit(
                                        {
                                            ...newUnit,
                                            beaconMajor: Number(e.target.value)
                                        }
                                    )
                                }
                            />
                        </FormGroup> */}
                        <div className='row'>
                            { addModal && accessTypes.length >0 &&  <div className='col-6'>
                                <FormGroup>
                                    <Label for="lockType">
                                        Access
                                    </Label>
                                      <select
                                        className='form-control'
                                        onChange={(event) => {
                                            setIntegrationDrop([])
                                            if(Number(event.target.value) != 0){
                                                setIntegrationLoading(true)
                                                getIntegrationIds(Number(event.target.value));
                                            }
                                            setNewUnit({
                                                ...newUnit,
                                                lock_type: Number(Number(event.target.value)),
                                                keyCafeUnitKeys: [],
                                                smartRentRemoteUnitId: '',
                                            })
                                            if(errText === accessSelectionErr){
                                                setErrText('')
                                            }
                                        }}
                                        value={newUnit.lock_type}
                                    >
                                         <option value={0}>Select</option>
                                        {
                                            accessTypes.map((access)=>{
                                                return <option value={access.id}>{access.option}</option>
                                            })
                                        }
                                    </select> 
                                </FormGroup>
                                <FormGroup style={{ position: 'relative' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    { newUnit.lock_type === 9 ? <MinimalMultiSelect 
                                       heading={newUnit.keyCafeUnitKeys.map((group: any) => group.keyId).length>0? newUnit.keyCafeUnitKeys.map((group: any) => group.keyId).length + (newUnit.keyCafeUnitKeys.map((group: any) => group.keyId).length === 1? ' Key Selected': ' Keys Selected') : 'Select Keys'}
                                       listItems={integrationDrop.map((group: any) => ({ name: group.keyName, id: group.keyId }))} 
                                       selectedIds={newUnit.keyCafeUnitKeys.map((group: any) => group.keyId)}
                                       setSelectedIds={function (ids: any[]): void {
                                            const selectedKeys = integrationDrop.filter((key: any) => ids.includes(key.keyId));
                                            setNewUnit({
                                                ...newUnit,
                                                keyCafeUnitKeys: selectedKeys
                                            })
                                        }}
                                      /> :
                                      <SearchableDropdownClear
                                         onBlur={(lock_info: any) => {
                                            if(lock_info && newUnit.lock_type === 8){
                                                activateMasterLock(props.propertyId, lock_info).then(async result => {
                                                    if (result.data && result.data.toString() === 'Activation failed') {
                                                        setErrText('Please provide a valid lock')
                                                     }
                                                     else {
                                                        setLockSubmitted(true)
                                                     }
                                                });
                                            }
                                            setNewUnit({
                                                ...newUnit,
                                                smartRentRemoteUnitId: lock_info?lock_info.toString(): '', // Set to empty if null
                                            });
                                          }}
                                          handleInputChange={(lock_info: any)=>{
                                            setNewUnit({
                                                ...newUnit,
                                                smartRentRemoteUnitId: lock_info?lock_info.toString(): '', // Set to empty if null
                                            });
                                            if(lock_info){
                                                setErrText('')
                                            }
                                        }}
                                        hideNoResultsFound={true}
                                        heading={integrationLoading ? "Loading..." : "Integration Id"}
                                        listItems={integrationDrop.sort((a: any, b: any) => {
                                            const nameA = a.unit_name.toLowerCase();
                                            const nameB = b.unit_name.toLowerCase();
                                
                                            // Numeric and alphabetical sort
                                            return nameA.localeCompare(nameB, undefined, {
                                                numeric: true,
                                                sensitivity: 'base',
                                            });
                                        }).map((integration: any) => ({
                                                name: `${integration.unit_name} : ${integration.unit_id}`,
                                                value: integration.unit_id,
                                            }))}
                                        selectedId={newUnit.smartRentRemoteUnitId}
                                        setSelectedId={(id: number | null) => {
                                                setNewUnit({
                                                    ...newUnit,
                                                    smartRentRemoteUnitId: id?id.toString(): '', // Set to empty if null
                                                });
                                            }}
                                     />}
                                      { errText && <p style={{ color: 'red' }}>{errText}</p>}
                                    </div>
                                </FormGroup>
                            </div>}
                            <div className='col-6'>
                                <FormGroup>
                                    <Label for="beaconMajor">
                                        Beacon ID
                                    </Label>
                                    <Input
                                        id="beaconMajor"
                                        type="number"
                                        onChange={(e) =>
                                            setNewUnit(
                                                {
                                                    ...newUnit,
                                                    beaconMajor: Number(e.target.value)
                                                }
                                            )
                                        }
                                    />
                                </FormGroup>
                            </div>
                        </div>
                        <div className='row w-100 m-0'>
                            <div className='col p-0'>
                                <Label for="description">
                                    Directions
                                </Label>
                                <RichTextEditor
                                    value={newUnit.directions}
                                    onChange={(value: any) => {
                                        setNewUnit(
                                            {
                                                ...newUnit,
                                                directions: value
                                            }
                                        )
                                    }

                                    }
                                />
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div style={{ display: "flex", alignItems: "center" }} className='col-6'>
                                <span style={{ marginRight: "10px" }}>Available to Tour</span>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        role="switch"
                                        checked={newUnit.access_enabled}
                                        onChange={(event) => {
                                            const isChecked = event.target.checked;
                                            if (isChecked) {
                                                setShowAvailableForTour(true)
                                            } else {
                                                setNewUnit(
                                                    {
                                                        ...newUnit,
                                                        access_enabled: isChecked
                                                    }
                                                )
                                            }
                                        }}
                                    />
                                    <span className="slider round" />
                                </label>
                            </div>
                            {activeTab === "1" && <div style={{ display: "flex", alignItems: "center" }} className='col-6'>
                                <span style={{ marginRight: "10px" }}>Model Unit</span>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        role="switch"
                                        onChange={() => {
                                            setNewUnit(
                                                {
                                                    ...newUnit,
                                                    model_unit: true
                                                }
                                            )
                                        }
                                        }
                                    />
                                    <span className="slider round" />
                                </label>
                            </div>}
                        </div>
                        <div className='row mt-3'>
                            {/* <div style={{ display: "flex", alignItems: "center" }} className='col-6'>
                                <span style={{ marginRight: "10px" }}>Available to Lease </span>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        role="switch"
                                        onChange={() => {
                                            setNewUnit(
                                                {
                                                    ...newUnit,
                                                    available: true,
                                                }
                                            )
                                        }
                                        }
                                    />
                                    <span className="slider round" />
                                </label>
                            </div> */}
                            {/* {propInfo && propInfo.syncPropertyUnitsAvailability &&
                                <div style={{ display: "flex", alignItems: "center" }} className='col-6'>
                                    <span style={{ marginRight: "10px" }}>Sync </span>
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            role="switch"
                                            onChange={() => {
                                                setEditUnit(
                                                    {
                                                        ...newUnit,
                                                        syncUnitAvailability: true,
                                                    }
                                                )
                                            }
                                            }
                                        />
                                        <span className="slider round" />
                                    </label>
                                </div>
                            } */}
                        </div>
                    </div>


                </ModalBody>
                <ModalFooter>
                    <Button text="Cancel" addlClassName="btn-secondary" onClick={toggleAdd} />
                    {' '}
                    <Button text="Confirm" addlClassName="btn-primary" onClick={() => {
                        if(newUnit.lock_type !==null && newUnit.lock_type !== 0 && newUnit.smartRentRemoteUnitId ==="" && newUnit.keyCafeUnitKeys.length === 0){
                            setErrText(integrationIdErr);
                        } else if((newUnit.lock_type == null || newUnit.lock_type == 0) && newUnit.smartRentRemoteUnitId !== ""){
                            setErrText(accessSelectionErr)
                        } else{
                            toggleAdd();
                            handleAdd(newUnit);   
                        }
                    }} />
                </ModalFooter>
            </Modal>
            {/* for editing on table directly */}
            <Modal isOpen={modifyFlagUnitDetails !== undefined || showTourEnableDetails !== undefined}>
                <ModalBody>
                    <FormValidationDisplay errorMessage={deletionError} />
                    <div>
                        <h4>Unit Available to Tour CheckList</h4>
                        <ol>
                            <li>Confirm the unit is ready to tour.</li>
                            <li>Insert directions to the unit.</li>
                            <li>Confirm that access to the unit is set-up.</li>
                            <li>
                                If you use beacons:
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>Physically relocate beacons to the designated tour unit(s).</li>
                                    <li>Confirm that the beacon ID is updated to match the unit's specifications.</li>
                                </ul>
                            </li>
                        </ol>
                        <div className="deletion-popup-buttons" role="group">
                            <Button
                                text="Enable"
                                onClick={() => {
                                    if(modifyFlagUnitDetails){
                                        const unit: propertyUnits = {
                                            ...modifyFlagUnitDetails!,
                                            access_enabled: !modifyFlagUnitDetails!.access_enabled,
                                        };
                                        setModifyFlagUnitDetails(undefined)
                                        handleModifyFlag(unit);
                                    } else if(showTourEnableDetails){
                                        const unit: propertyUnits = {
                                            ...showTourEnableDetails!,
                                            access_enabled: !showTourEnableDetails!.access_enabled,
                                        };
                                        setEditUnit(unit)
                                        setShowTourEnableDetails(undefined)
                                    }
                                   
                                }}
                                addlClassName="btn-primary"
                                suppressBottomMargin={true}
                            />
                            <Button
                                text="Cancel"
                                onClick={() => {
                                    if(modifyFlagUnitDetails){
                                        setModifyFlagUnitDetails(undefined)
                                    }  else if(showTourEnableDetails){
                                        setShowTourEnableDetails(undefined)
                                    }
                                }}
                                addlClassName="btn-secondary"
                                suppressBottomMargin={true}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={showAvailableForTour}>
                <ModalBody>
                    <FormValidationDisplay errorMessage={deletionError} />
                    <div>
                        <h4>Unit Available to Tour CheckList</h4>
                        <ol>
                            <li>Confirm the unit is ready to tour.</li>
                            <li>Insert directions to the unit.</li>
                            <li>Confirm that access to the unit is set-up.</li>
                            <li>
                                If you use beacons:
                                <ul style={{ paddingLeft: '20px' }}>
                                    <li>Physically relocate beacons to the designated tour unit(s).</li>
                                    <li>Confirm that the beacon ID is updated to match the unit's specifications.</li>
                                </ul>
                            </li>
                        </ol>
                        <div className="deletion-popup-buttons" role="group">
                            <Button
                                text="Enable"
                                onClick={() => {
                                    if (editUnit) {
                                        setEditUnit((prevEditUnit) => ({
                                            ...prevEditUnit!,
                                            access_enabled: true
                                        }))
                                    } else {
                                        setNewUnit((prevEditUnit) => ({
                                            ...prevEditUnit!,
                                            access_enabled: true
                                        }))
                                    }

                                    setShowAvailableForTour(false)
                                }}
                                addlClassName="btn-primary"
                                suppressBottomMargin={true}
                            />
                            <Button
                                text="Cancel"
                                onClick={() => setShowAvailableForTour(false)}
                                addlClassName="btn-secondary"
                                suppressBottomMargin={true}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={availability !== null && Object.keys(availability).length > 0}>
                <ModalBody>
        {updateCountLoading ? (
            <LoadingDisplay />
        ) : (
            <div>
                { availability.success && availability.UnitsVacant && availability.UnitsOccupied ? (
                    <React.Fragment>
                        <p> No of Units Vacant are <b>{availability.UnitsVacant}</b></p>
                        <p> No of Units Occupied are <b>{availability.UnitsOccupied}</b></p>
                    </React.Fragment>
                ) : (
                    <p>{availability.data}</p>
                )}
                { !availability.success && (
                    <p>{availability.error}</p>
                )}
                <div className="deletion-popup-buttons">
                    <Button
                        text="Ok"
                        onClick={() => setAvailability({})}
                        addlClassName="deletion-cancel"
                        suppressBottomMargin={true}
                    />
                </div>
            </div>
        )}
                </ModalBody>
            </Modal>

            <Modal isOpen={deletionUnitId != 0}>
                <ModalBody>
                    <FormValidationDisplay errorMessage={deletionError} />
                    {deletionLoading ? (
                        <LoadingDisplay />
                    ) : (
                        <div>
                            <h4>Are you sure you want to delete Unit?</h4>
                            <p>
                                You will not be able to access any past or future information of this Unit.
                            </p>
                            <div className="deletion-popup-buttons">
                                <Button
                                    text="Yes, Delete Unit"
                                    onClick={() => handleDelete(deletionUnitId)}
                                    addlClassName="btn-danger"
                                    suppressBottomMargin={true}
                                />
                                <Button
                                    text="Cancel"
                                    onClick={() => setDeletionUnitId(0)}
                                    addlClassName="deletion-cancel"
                                    suppressBottomMargin={true}
                                />
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>
            <Modal isOpen={showOccupied} onClose={handleShowOccupied}>
                <ModalBody>
                    <div>
                        <p>
                            {availabilityDialog[propertyType]}
                        </p>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button text="Close" addlClassName="btn-primary" onClick={handleShowOccupied} />
                </ModalFooter>
            </Modal>
        </div >
    );
}


// private handleUploadCSV() {
//     this.setState({
//         ...this.state,
//         isLoading: true
//     });
// }

// private handleApiResult<T>(result: ApiResult<T>) {
//     if (result.success) {
//         this.loadData();
//     } else {
//         let errorMessage =
//             result.error === undefined || result.error === ''
//                 ? 'Error contacting server'
//                 : result.error;
//         this.setState({
//             ...this.state,
//             errorMessage: errorMessage,
//             isLoading: false
//         });
//     }
// }

export default UnitManagementTab;




// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/UnitManagement.tsx